<div class="percent relative"
    [style]="{'--percent': value(), width: responsiveWidth + 'px', height: responsiveHeight + 'px'}">
    <svg [attr.viewBox]="'0 0 ' + responsiveWidth + ' ' + responsiveHeight" [attr.width]="responsiveWidth"
        [attr.height]="responsiveHeight">
        <circle class="track" [attr.cx]="responsiveWidth/2" [attr.cy]="responsiveHeight/2" [attr.r]="radius"
            [attr.stroke]="background()" pathLength="100" [attr.stroke-width]="size()" fill="none">
        </circle>
        <circle class="transition-all duration-300 ease-expo progress-semgnets" [attr.cx]="responsiveWidth/2"
            [attr.cy]="responsiveHeight/2" fill="none" [attr.stroke]="color()" [attr.r]="radius"
            [attr.stroke-width]="size()" pathLength="100"
            [ngClass]="{'!stroke-transparent': (value() == 0 && !isViewInit())}"
            [attr.transform]="'rotate(-90 ' + responsiveWidth/2 + ' ' + responsiveHeight/2 + ')'">
        </circle>
        <foreignObject [attr.x]="0" [attr.y]="0" [attr.width]="responsiveWidth" [attr.height]="responsiveHeight"
            pointer-events="none">
            <div xmlns="http://www.w3.org/1999/xhtml" class="flex w-full h-full justify-center items-center">
                <div class="flex flex-col items-center justify-center w-fit h-fit">
                    <p class="text-zen font-medium" [style.fontSize.px]="widthInRem() + 10">
                        {{displayValue()}}{{ hasDisplayOverride() ? '' : '%' }}</p>
                    <ng-content></ng-content>
                </div>
            </div>
        </foreignObject>
    </svg>
</div>